import { render, staticRenderFns } from "./createAdminFranchiseNurse.vue?vue&type=template&id=a1e8d4e0&scoped=true&"
import script from "./createAdminFranchiseNurse.vue?vue&type=script&lang=js&"
export * from "./createAdminFranchiseNurse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1e8d4e0",
  null
  
)

export default component.exports